import { Avatar, Button, Drawer, PopperoDrawero, Rating, Tag } from "@pinkyhead/dovekit";
import { ReactComponent as MapIcon } from "../../../assets/icons/regular/map.svg";
import { ReactComponent as ListIcon } from "../../../assets/icons/regular/list.svg";
import { useResults } from "./Results.hooks"
import { DataType, ResultsProps } from "./Results.interface";
import { Container, DetailsHeader, HeaderContainer, ListContainer } from "./Results.styles"
import { MyLocation } from "../../common/MyLocation";
import { TagIcons } from "../TagIcons";
import { IconContainer } from "../Card/Card.styles";
import { pickUserIcon } from "../../common/Icon/utils";

export const Results = ({ children, type }: ResultsProps) => {
  const { open, setOpen, userData, redirectToProfile } = useResults();
  return (
    <>
      {/* {!open &&
        <MyLocation />
      } */}
      {open &&
        <Container className={open ? "open" : ""}>
          {children}
        </Container>
      }
      <HeaderContainer>
        {type === DataType.LIST &&
          <Button
            size="small"
            variant="tertiary"
            icon={open ? <MapIcon /> : <ListIcon />}
            onClick={() => setOpen(!open)}
          >
            {open ? "Show on map" : "Show List"}
          </Button>
        }
        {(type === DataType.DETAIL && userData) &&
          <div className="detail">
            <div className="avatar-container">
              {userData.picture
                ?
                  <Avatar 
                    displayName={userData.searchName}
                    picture={userData.picture}
                    size={70}
                    fontSize={16}
                  />
                : 
                  <IconContainer
                    isClaimed={userData.extraFilters.isClaimed}
                    isPremium={userData.extraFilters.isPremium}
                    isRecommended={userData.extraFilters.isRecommended}
                  >
                    <img src={pickUserIcon(userData.itemType)} alt="User icon" />
                  </IconContainer>
              }
              <Rating varinat="star" value={userData.rating} />
            </div>
            <div className="user-info">
              <div>
                <span className="display-name">{userData.searchName}</span>
                <Tag name="Family Medicine" />
                <span className="address">{userData.address}</span>
              </div>
              <Button size="small" fullWidth onClick={() => redirectToProfile(userData.id)}>View Profile</Button>
            </div>
          </div>
        }
      </HeaderContainer>
    </>
  )
}
